import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6547e388"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }

export interface IProps {
    title?: string;
    description?: string;
    image?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    description: null,
    image: null
  },
  setup(__props: any) {

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner",
    style: _normalizeStyle({ backgroundImage: `url('${__props.image}')` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1)
    ])
  ], 4))
}
}

})